var __default__ = {root:'m_96b553a6'};
export default __default__;